import React from "react";
import { Navigate, useLocation } from "react-router-dom";

// Constants
import {
    HOME,
    // DOCUMENT_CONFIRMATION,
    LOGIN
} from "./constants";
import {
    EVENT_ADMIN,
    EVENT_VIEWER,
    TICKET_CONTROL,
    decodeAuth,
    eventIdFromPath,
    hasAnyEventRole,
    isAdminAnywhere,
    roleFor,
} from "../pages/DashboardPage/components/useRole";

// isEventAdmin: only the event's admins; isEventStaff: admins and the event's
// owner; isEventDoor: those two plus the people scanning tickets. The role is
// the one this account has on the event in the URL — it may be a different one
// on the next event.
const AuthCheck = ({ children, isPrivate, isEventAdmin, isEventStaff, isEventDoor, elementForAuthenticated, redirectUrlForAuthenticated }) => {
    const auth = localStorage.getItem('auth');
    const decoded = decodeAuth();
    let location = useLocation();

    const eventId = eventIdFromPath(location.pathname);
    const role = roleFor(decoded, eventId);
    // The pages that are about no event in particular (the event list,
    // create-event) ask what this account is anywhere
    const allowed = (roles) => (eventId
        ? roles.includes(role)
        : (roles.includes(TICKET_CONTROL) ? hasAnyEventRole(decoded) : isAdminAnywhere(decoded)));
    // where someone is sent when this page is not theirs: the event they came for
    const eventHome = eventId ? `/dashboard/${eventId}` : HOME;

    if (redirectUrlForAuthenticated && decoded?.isVerified && !decoded?.isReset) {
        return <Navigate
            to={{
                pathname: HOME,
                state: { from: location }
            }}
        />;
    }

    if (isEventAdmin && !auth) {
        return <Navigate
            to={{
                pathname: LOGIN,
                state: { from: location }
            }}
        />;
    }

    if (isPrivate && !auth) {
        return <Navigate
            to={{
                pathname: LOGIN,
                state: { from: location }
            }}
        />;
    }

    if (isEventDoor && !allowed([EVENT_ADMIN, EVENT_VIEWER, TICKET_CONTROL])) {
        return <Navigate to={HOME} replace />;
    }

    if (isEventStaff && !allowed([EVENT_ADMIN, EVENT_VIEWER])) {
        // Door staff get sent back to the event they came from
        if (role === TICKET_CONTROL) {
            return <Navigate to={eventHome} replace />;
        }
        return <Navigate to={HOME} replace />;
    }

    if (isEventAdmin && !allowed([EVENT_ADMIN])) {
        // Everyone else lands on the event they are allowed to see
        if ([EVENT_VIEWER, TICKET_CONTROL].includes(role)) {
            return <Navigate to={eventHome} replace />;
        }
        return <Navigate to={HOME} replace />;
    }

    if (elementForAuthenticated && decoded?.isVerified && !decoded?.isReset) {
        return elementForAuthenticated;
    }

    return children;
}

export default AuthCheck;
